import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import { $get, $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { InputRules } from "@/rules";
import { ShiftPattern } from "@/models/transaction/ShiftPattern";
import BeforeAfterList from "@/components/list/BeforeAfterList.vue";
import { $alert } from "@/plugins/alert/alert";
import { ShiftFlowDat } from "@/models/transaction/ShiftFlowDat";
import { DateTime } from "luxon";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

type Props = {
  disabled: boolean;
  item: ShiftFlowDat;
};
type Emits = {
  (e: "close"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftDialog',
  props: {
    disabled: { type: Boolean },
    item: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disabled: boolean;
  item: ShiftFlowDat;
};

const beforeHeader = [
  { text: "シフト名： ", value: "preShiftpatternNm" },
  { text: "シフト開始時間： ", value: "preStartTime" },
  { text: "シフト終了時間： ", value: "preEndTime" },
  { text: "シフト総休憩時間： ", value: "preBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "preMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "preMidnightBreakTime" }
] as const;

const afterHeader = [
  { text: "シフト名： ", value: "afterShiftpatternNm" },
  { text: "シフト開始時間： ", value: "afterStartTime" },
  { text: "シフト終了時間： ", value: "afterEndTime" },
  { text: "シフト総休憩時間： ", value: "afterBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "afterMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "afterMidnightBreakTime" }
] as const;




const isOpen = ref(false);

const vform = ref<VForm>();

const items = ref<ShiftPattern[]>([]);

const selectItem = ref<ShiftPattern>();

const isLoading = ref(false);

const dat = ref(Object.assign({}, props.item));

const sqlToFormatTime = (time: string) => {
  const date = DateTime.fromISO(time);
  return date.isValid ? date.toFormat("HH:mm") : null;
};

watch(selectItem, (newValue?: ShiftPattern) => {
  if (newValue) {
    const value = dat.value;
    value.afterShiftpatternId = newValue.shiftPatternId;
    value.afterShiftpatternNm = newValue.shiftPatternName;
    value.afterStartTime = sqlToFormatTime(newValue.startTime);
    value.afterEndTime = sqlToFormatTime(newValue.endTime);
    value.afterBreakTime = sqlToFormatTime(newValue.breakTime);
    value.afterMorningBreakTime = sqlToFormatTime(newValue.morningBreakTime);
    value.afterMidnightBreakTime = sqlToFormatTime(newValue.midnightBreakTime);
  }
});

const getShiftPattern = async () => {
  const result = await $get<ShiftPattern[]>(
    `${Paths.approval.shiftPattern}/${props.item.affiliationId}`
  );
  if (result) items.value = result;
};

const onClose = () => {
  isOpen.value = false;
  emits("close");
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", "入力に誤りがあります。\n入力内容を確認してください。");
    return;
  }

  isLoading.value = true;
  const result = await $post(Paths.approval.shift.update, dat.value);
  if (result) {
    $alert("success", "変更に成功しました。");
    onClose();
  } else {
    $alert("error", "変更に失敗しました。");
  }
  isLoading.value = false;
};

const initialize = async () => {
  await getShiftPattern();
  dat.value = Object.assign({}, props.item);
  selectItem.value = items.value.find(
    e => e.shiftPatternId === dat.value.afterShiftpatternId
  );
};

watch(isOpen, async (val: boolean) => {
  if (val) {
    await initialize();
  }
});

return { __sfc: true,beforeHeader, afterHeader, props, emits, isOpen, vform, items, selectItem, isLoading, dat, sqlToFormatTime, getShiftPattern, onClose, onSubmit, initialize, InputRules, BeforeAfterList }
}

})